"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_config_1 = require("react-router-config");
const array_1 = require("../../../common/js/helper/array");
const Paths_1 = require("../../constants/Paths");
const PortalAreas_1 = __importDefault(require("../../enums/PortalAreas"));
const PORTAL_AREA_HEADER = 'portal-area';
class PortalAreaMiddleware {
    pre(context) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { fetch, ...fetchParams } = context;
        const promise = Promise.resolve();
        const headers = new Headers(fetchParams.init.headers);
        if (!headers.has(PORTAL_AREA_HEADER)) {
            const routeMatch = (0, array_1.first)((0, react_router_config_1.matchRoutes)([{ path: Paths_1.PATH_SHOP_CHECKOUT }], document.location.pathname));
            headers.set(PORTAL_AREA_HEADER, routeMatch ? PortalAreas_1.default.CHECKOUT : PortalAreas_1.default.SHOP);
            fetchParams.init.headers = headers;
        }
        return promise.then(() => {
            return fetchParams;
        });
    }
}
exports.default = new PortalAreaMiddleware();
